import { render, staticRenderFns } from "./myCommonBox.vue?vue&type=template&id=412c0c5c&scoped=true&"
import script from "./myCommonBox.vue?vue&type=script&lang=js&"
export * from "./myCommonBox.vue?vue&type=script&lang=js&"
import style0 from "./myCommonBox.vue?vue&type=style&index=0&id=412c0c5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c0c5c",
  null
  
)

export default component.exports